export default "__VITE_ASSET__DK460Ad2__"